module.exports = __webpack_public_path__ + "img/get-ready-bg-left.43cbfe7c.png";